// extracted by mini-css-extract-plugin
export default {"pusat_bantuan":"whatsapp_pusat_bantuan__iIYa-","shake":"whatsapp_shake__4k5X4"};